export default class TypeUtil {
  static asString(value: any): string | undefined {
    switch (typeof value) {
      case "string":
        return value
      case "number":
        return value.toString()
      default:
        return undefined
    }
  }

  static asNumber(value: any): number | undefined {
    switch (typeof value) {
      case "number":
        return this.asActualNumber(value)
      case "string":
        return this.asActualNumber(Number(value))
      default:
        return undefined
    }
  }

  private static asActualNumber(number: number): number | undefined {
    if (!isNaN(number) && isFinite(number)) {
      return number
    } else {
      return undefined
    }
  }
}
